// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Ouroboros_Models_Brands_SectionID from "../Ouroboros.Models.Brands.SectionID/index.js";
import * as Ouroboros_Models_Brands_SectionIndex from "../Ouroboros.Models.Brands.SectionIndex/index.js";
var eq1 = /* #__PURE__ */ Data_Eq.eq(Ouroboros_Models_Brands_SectionID.eqSectionID);
var eq2 = /* #__PURE__ */ Data_Eq.eq(Ouroboros_Models_Brands_SectionIndex.eqSectionIndex);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var isUnstartedPlaceholder = function (value) {
    var normalized = Data_String_Common.trim(value);
    return Data_String_CodeUnits.contains("hasn't been started")(normalized) || Data_String_CodeUnits.contains("has not been started")(normalized);
};
var updateSection = function (document) {
    return function (updatedSection) {
        var hasUpdatedContents = (function () {
            if (updatedSection.section_contents instanceof Data_Maybe.Nothing) {
                return false;
            };
            if (updatedSection.section_contents instanceof Data_Maybe.Just) {
                return Data_String_Common.trim(updatedSection.section_contents.value0) !== "";
            };
            throw new Error("Failed pattern match at Ouroboros.Models.Documents.DocumentMutations (line 39, column 7 - line 41, column 39): " + [ updatedSection.section_contents.constructor.name ]);
        })();
        var hasNameMatch = Data_Array.any(function (section) {
            return section.metadata.name === updatedSection.metadata.name;
        })(document.document_contents);
        var hasIdOrIndexMatch = Data_Array.any(function (section) {
            return eq1(section.metadata.id)(updatedSection.metadata.id) || eq2(section.metadata.index)(updatedSection.metadata.index);
        })(document.document_contents);
        var fallbackIndex = (function () {
            var $12 = hasIdOrIndexMatch || (hasNameMatch || !hasUpdatedContents);
            if ($12) {
                return Data_Maybe.Nothing.value;
            };
            return Data_Array.findIndex(function (section) {
                if (section.section_contents instanceof Data_Maybe.Nothing) {
                    return true;
                };
                if (section.section_contents instanceof Data_Maybe.Just) {
                    return Data_String_Common.trim(section.section_contents.value0) === "" || isUnstartedPlaceholder(section.section_contents.value0);
                };
                throw new Error("Failed pattern match at Ouroboros.Models.Documents.DocumentMutations (line 49, column 13 - line 51, column 77): " + [ section.section_contents.constructor.name ]);
            })(document.document_contents);
        })();
        var shouldReplace = function (index) {
            return function (section) {
                if (hasIdOrIndexMatch) {
                    return eq1(section.metadata.id)(updatedSection.metadata.id) || eq2(section.metadata.index)(updatedSection.metadata.index);
                };
                if (hasNameMatch) {
                    return section.metadata.name === updatedSection.metadata.name;
                };
                if (Data_Boolean.otherwise) {
                    if (fallbackIndex instanceof Data_Maybe.Just) {
                        return fallbackIndex.value0 === index;
                    };
                    if (fallbackIndex instanceof Data_Maybe.Nothing) {
                        return false;
                    };
                    throw new Error("Failed pattern match at Ouroboros.Models.Documents.DocumentMutations (line 62, column 11 - line 64, column 29): " + [ fallbackIndex.constructor.name ]);
                };
                throw new Error("Failed pattern match at Ouroboros.Models.Documents.DocumentMutations (line 55, column 5 - line 64, column 29): " + [ index.constructor.name, section.constructor.name ]);
            };
        };
        return {
            name: document.name,
            id: document.id,
            document_contents: Data_Array.mapWithIndex(function (index) {
                return function (section) {
                    var $19 = shouldReplace(index)(section);
                    if ($19) {
                        return updatedSection;
                    };
                    return section;
                };
            })(document.document_contents)
        };
    };
};
var appendSection = function (document) {
    return function (newSection) {
        return {
            name: document.name,
            id: document.id,
            document_contents: append(document.document_contents)([ newSection ])
        };
    };
};
export {
    updateSection,
    appendSection
};
//# sourceMappingURL=index.js.map
